import {makeStyles} from '@material-ui/core/styles'
import { reExportedColors, DeleteIconButton, Text } from '../../../1elements'
import FormTextField from '../../../2compounds/FormTextField'
import DataTypeDropDown from '../../../2compounds/Select/DataTypeDropDown'
import DragIconButton from '../../../1elements/Buttons/IconButtons/DragIconButton'
import ShowHideButton from '../../../1elements/Buttons/IconButtons/ShowHideButton'
import useAdminEditItem from './useAdminEditItem'
import { Reorder } from "framer-motion"
import {validateFieldLabel} from '../../../../services/util/editChecks'


const AdminEditItem = ({item, fieldIndex, updateDataType, index, updateFieldLabel, className, toggleIsHidden, toggleDeleteConfirmationModal}) => {
    const classes = useStyles()
    const {controls, boxShadow, y} = useAdminEditItem()
    const {label, isMandatory, type, isHidden} = item

    return (
        <Reorder.Item key={item.fieldId} id={item.fieldId} value={item} dragListener={false} dragControls={controls} className={`${classes.reorderInnerDiv} ${isHidden?classes.reorderInnerDivHidden:''} ${className}`} style={{ boxShadow, y }}>
            <DragIconButton controls={controls} />
            {!isMandatory ? <ShowHideButton show={!isHidden} toggleIsHidden={()=>toggleIsHidden(index, fieldIndex)} className={classes.showHideButton} /> : <div className={classes.spacer} />}
            {!isMandatory
              ? <>
                  <FormTextField value={label} onChange={(newValue) => updateFieldLabel(index, fieldIndex, newValue)}
                               className={classes.textField} rows validation={validateFieldLabel(label)}/>:<span>&nbsp;</span>
                </>
              : <>
                <Text>{label}</Text>:<span>&nbsp;</span>
                </>}

            <DataTypeDropDown disabled={isMandatory} value={type} onChange={(newValue) => updateDataType(index, fieldIndex, newValue)} className={classes.typeDropDown} />
            {!isMandatory && <DeleteIconButton onClick={()=>toggleDeleteConfirmationModal(index, fieldIndex)} className={classes.iconButton} />}
        </Reorder.Item>
    )
}

export default AdminEditItem

const useStyles = makeStyles((theme)=>({
  label: {
    marginLeft: 5,
    whiteSpace: 'nowrap'
  },
  textField: {
    '& .MuiInputBase-input': {
      padding: '1px 3px !important'
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0
    }
  },
  reorderInnerDiv: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridTemplateRows: '1fr',
    gridTemplateColumns: '16px 40px 1fr 10px 10px 150px 30px',
    userSelect: 'none',
    backgroundColor: reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    border: props => props.onDrag && '1px solid red',
    zIndex: props => props.onDrag && 5,
    margin: '5px 0'
  },
  reorderInnerDivHidden: {
    '& .MuiFormControl-root': {
      opacity: .6,
    },
    reorderInnerDiv: {
        display: 'flex',
        userSelect: 'none',
        backgroundColor: theme.palette.quaternary.main,
        border: props => props.onDrag && '1px solid red',
        zIndex: props => props.onDrag && 5,
        margin: '5px 0'
    },
    reorderInnerDivHidden: {
        '& .MuiFormControl-root': {
            opacity: .6,
        },
        '&>*': {
            boxShadow: 'none'
        }
    },
    spacer: {
        width: 30
    },
    typeDropDown: {
        // marginTop: -3,
        height: 20,
        '& .MuiSelect-select': {
            height: 20
        },
    },
    showHideButton: {
        marginRight: 0,
    },
  },
  showHideButton: {
    margin: '0 auto',
    height: 20,
    width: 20
  },
  iconButton: {
    padding: 0,
    height: 24
  }
}))